import SupportComponent from "./components/support.component";

const supportContainer = document.querySelector("#helpContent");
if (supportContainer) {
  let supportComponent = new SupportComponent(supportContainer);
}